// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-wrapper {
    width: 100vw;
    height: 100vh;
    margin: 0;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
  }
  
  .loader-wrapper .circle {
    width: 8vmax;
    height: 8vmax;
    margin-bottom: 20px;
    border-right: 4px solid #E20F6F;
    border-radius: 100%;
    background-color: transparent;
    animation: spinRight 800ms linear infinite;
  }
  .circle:before, .circle:after {
    content: "";
    width: 6vmax;
    height: 6vmax;
    display: block;
    position: absolute;
    top: calc(50% - 3vmax);
    left: calc(50% - 3vmax);
    border-left: 3px solid #264EC8;
    border-radius: 100%;
    animation: spinLeft 800ms linear infinite;
  }
  .circle:after {
    width: 4vmax;
    height: 4vmax;
    top: calc(50% - 2vmax);
    left: calc(50% - 2vmax);
    border: 0;
    border-right: 2px solid #7380FF;
    animation: none;
  }
  
  @keyframes spinLeft {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(720deg);
    }
  }
  @keyframes spinRight {
    from {
      transform: rotate(360deg);
    }
    to {
      transform: rotate(0deg);
    }
  }`, "",{"version":3,"sources":["webpack://./src/component/common/Loader/Loader.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,MAAM;IACN,OAAO;EACT;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,mBAAmB;IACnB,6BAA6B;IAErB,0CAA0C;EACpD;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB;IAEX,yCAAyC;EACnD;EACA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,+BAA+B;IAEvB,eAAe;EACzB;;EAWA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;EASA;IACE;MACE,yBAAyB;IAC3B;IACA;MACE,uBAAuB;IACzB;EACF","sourcesContent":[".loader-wrapper {\n    width: 100vw;\n    height: 100vh;\n    margin: 0;\n    background-color: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    flex-direction: column;\n    position: fixed;\n    top: 0;\n    left: 0;\n  }\n  \n  .loader-wrapper .circle {\n    width: 8vmax;\n    height: 8vmax;\n    margin-bottom: 20px;\n    border-right: 4px solid #E20F6F;\n    border-radius: 100%;\n    background-color: transparent;\n    -webkit-animation: spinRight 800ms linear infinite;\n            animation: spinRight 800ms linear infinite;\n  }\n  .circle:before, .circle:after {\n    content: \"\";\n    width: 6vmax;\n    height: 6vmax;\n    display: block;\n    position: absolute;\n    top: calc(50% - 3vmax);\n    left: calc(50% - 3vmax);\n    border-left: 3px solid #264EC8;\n    border-radius: 100%;\n    -webkit-animation: spinLeft 800ms linear infinite;\n            animation: spinLeft 800ms linear infinite;\n  }\n  .circle:after {\n    width: 4vmax;\n    height: 4vmax;\n    top: calc(50% - 2vmax);\n    left: calc(50% - 2vmax);\n    border: 0;\n    border-right: 2px solid #7380FF;\n    -webkit-animation: none;\n            animation: none;\n  }\n  \n  @-webkit-keyframes spinLeft {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(720deg);\n    }\n  }\n  \n  @keyframes spinLeft {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(720deg);\n    }\n  }\n  @-webkit-keyframes spinRight {\n    from {\n      transform: rotate(360deg);\n    }\n    to {\n      transform: rotate(0deg);\n    }\n  }\n  @keyframes spinRight {\n    from {\n      transform: rotate(360deg);\n    }\n    to {\n      transform: rotate(0deg);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
